import lodash from 'lodash';
import qs from 'qs';
import _ from 'lodash';
import axios from '../axios';
import { poolHelper } from '../common/pool-pormise-helper';

const ACTIONS = {
    GET_CUSTOME_LEADER_BOARD_SUCCESS: 'GET_CUSTOME_LEADER_BOARD_SUCCESS',
    GET_CUSTOME_LEADER_BOARD_ERROR: 'GET_CUSTOME_LEADER_BOARD_ERROR',
    GET_TEAMS_LEADER_BOARD_SUCCESS: 'GET_TEAMS_LEADER_BOARD_SUCCESS',
    GET_TEAMS_LEADER_BOARD_ERROR: 'GET_TEAMS_LEADER_BOARD_ERROR',
    GET_YEAR_LEADER_BOARD_SUCCESS: 'GET_YEAR_LEADER_BOARD_SUCCESS',
    GET_YEAR_LEADER_BOARD_ERROR: 'GET_YEAR_LEADER_BOARD_ERROR',
    GET_REPORTS_LEADER_BOARD_SUCCESS: 'GET_REPORTS_LEADER_BOARD_SUCCESS',
    GET_REPORTS_LEADER_BOARD_ERROR: 'GET_REPORTS_LEADER_BOARD_ERROR',
    GET_ALL_TEAM_LEADER_BOARD_SUCCESS: 'GET_ALL_TEAM_LEADER_BOARD_SUCCESS',
    GET_ALL_TEAM_LEADER_BOARD_ERROR: 'GET_ALL_TEAM_LEADER_BOARD_ERROR',
    GET_CONTENT_TABLE_LOADING: 'GET_CONTENT_TABLE_LOADING',
    GET_CONTENT_TABLE_SUCCESS: 'GET_CONTENT_TABLE_SUCCESS',
    GET_CONTENT_TABLE_ERROR: 'GET_CONTENT_TABLE_ERROR',
    SORT_CONTENT_TABLE: 'SORT_CONTENT_TABLE',
    RESET_CONTENT_TABLE: 'RESET_CONTENT_TABLE',
    DELETE_CUSTOME_LEADER_BOARD_SUCCESS: 'DELETE_CUSTOME_LEADER_BOARD_SUCCESS',
    DELETE_CUSTOME_LEADER_BOARD_ERROR: 'DELETE_CUSTOME_LEADER_BOARD_ERROR',
    GET_REPORT_CONFIG_SUCCESS: 'GET_REPORT_CONFIG_SUCCESS',
    GET_REPORT_CONFIG_ERROR: 'GET_REPORT_CONFIG_ERROR',
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const resetTableList = () => {
    return (dispatch) => {
        dispatch({ type: ACTIONS.RESET_CONTENT_TABLE });
    }
};

const sortContentTable = (field, order) => {
    return (dispatch) => {
        dispatch({ type: ACTIONS.SORT_CONTENT_TABLE, field, order });
    }
};

const getCustomeLeaderBoard = () => {
    return async (dispatch) => {
        const response = await axios.get('api/leaderboards/customs');
        const list = response.data.map(item => {
            return {
                ...item,
                columns: item.columns === 'null' ? [] : JSON.parse(item.columns),
                filters: item.columns === 'null' ? [] : JSON.parse(item.filters),
            };
        });
        dispatch(updateStatus(ACTIONS.GET_CUSTOME_LEADER_BOARD_SUCCESS, list));
    };
};

const deleteCustomReport = (id) => {
    return async () => {
        return axios.delete(`api/leaderboards/customs/${id}`);
    };
};

const getPlayer = (id) => {
    return async () => {
        const { data } = await axios.get(`api/players/${id}`);
        return data;
    };
};

const getPlayerDetail = (ids) => {
    return async () => {
        try {
            let playerList = [];
            await poolHelper({
                data: ids,
                apiPath: (playerId) => {
                    return `api/players/${playerId}`
                },
                callbackSuccess: (response) => {
                    const playerDetail = response.data.result.data;
                    playerList.push({
                        id: playerDetail.id,
                        team: playerDetail.team,
                        player_name: playerDetail.player_name,
                        position_type: playerDetail.position_type,
                        register_name: playerDetail.register_name,
                        uniform_number: playerDetail.uniform_number,
                    });
                },
                callbackError: () => { },
            });

            return playerList;
        } catch (error) {
            console.log(error);
        }
    };
};

const getTeams = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get('api/masters/teams');
            dispatch(updateStatus(ACTIONS.GET_ALL_TEAM_LEADER_BOARD_SUCCESS, response.data));
        } catch (error) {
            console.log(error);
        }
    };
}

const getReportConfig = (reportId) => {
    return async (dispatch) => {
        try {
            const response = await axios.get(`/api/leaderboards/reports/${reportId}/configs`);

            let columns = response.data.columns || [];
            let filters = response.data.filters || [];
            const data = {
                columns: columns,
                filters: filters
            };
            dispatch(updateStatus(ACTIONS.GET_REPORT_CONFIG_SUCCESS, data));
            return data;
        } catch (error) {
            console.log(error);
        }
    };
}

const saveCustom = (params) => {
    return async () => {
        const response = await axios.post('api/leaderboards/customs', {
            name: params.name,
            report_id: params.reportId,
            year_id: params.yearId,
            team_ids: params.teamIds,
            player_ids: params.playerIds,
            columns: params.columns,
            sort: params.sort,
            order: params.order,
            filters: params.filters,
        });
        // console.log(response);
    }
};

const updateCustom = (params) => {
    return async () => {
        return await axios.put('api/leaderboards/customs/' + params.id, params);
    }
};


const formatData = (data, columns) => {
    return data.map(item => {
        let report = item.data;
        const result = [];
        columns.forEach(column => {
            if (column.children) {
                result.push(lodash.take(report, column.children.length));
                report.splice(0, column.children.length);
                return;
            }
            result.push(lodash.take(report, 1));
            report.splice(0, 1)
        })
        return {
            ...item,
            data: result,
            team: item.team || {},
            player: item.player || {
                team: {},
            },
        };
    })
}

const updateCustomList = (list) => {
    return async () => {
        await poolHelper({
            data: list,
            method: 'PUT',
            apiPath: ({ id }) => {
                return `api/leaderboards/customs/${id}`
            },
            callbackSuccess: () => { },
            callbackError: () => { },
        });
    }
};

const getPlayers = (params) => {
    return async () => {
        const { keyword, teamIds, startDate, endDate } = params;

        const { data } = await axios.get('/api/masters/players_retired', {
            params: {
                keyword,
                team_ids: teamIds,
                apply_start_ymd: startDate,
                apply_end_ymd: endDate,
            },
        });

        // idごとにグループ化 → 最新のapply_end_ymdを持つものだけ残す
        const latestPerId = _(data)
            .groupBy('id')
            .map((group) =>
                group.reduce((latest, current) => {
                    return Number(current.apply_end_ymd || 0) > Number(latest.apply_end_ymd || 0)
                        ? current
                        : latest;
                })
            )
            .value();

        return latestPerId;
    };
};

const getYear = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get('api/masters/years');
            dispatch(updateStatus(ACTIONS.GET_YEAR_LEADER_BOARD_SUCCESS, response.data));
        } catch (error) {
            console.log(error);
        }
    };
};

const getYearSeasonRanges = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get('api/masters/years_seasonranges');
            dispatch(updateStatus(ACTIONS.GET_YEAR_LEADER_BOARD_SUCCESS, response.data));
        } catch (error) {
            console.log(error);
        }
    };
};

const getReport = (id, params) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: ACTIONS.GET_CONTENT_TABLE_LOADING
            });
            const { data } = await axios.get(`api/leaderboards/reports/${id}`, {
                params,
                paramsSerializer: params => {
                    return qs.stringify(params)
                }
            });

            let hasTotal = false;
            const columns = data.columns;
            let size = 0;

            const dataFilter = formatData(data.data, columns);
            dispatch({
                type: ACTIONS.GET_CONTENT_TABLE_SUCCESS,
                data: {
                    ...data,
                    data: dataFilter,
                    columns,
                    size,
                    hasTotal,
                }
            });
        } catch (error) {
            dispatch({
                type: ACTIONS.GET_CONTENT_TABLE_ERROR,
            });
        }
    };
};

const getReports = () => {
    return async (dispatch) => {
        try {
            const response = await axios.get('api/leaderboards/reports');
            const player = response.data.player || {};
            const team = response.data.team || {};
            dispatch(updateStatus(ACTIONS.GET_REPORTS_LEADER_BOARD_SUCCESS, {
                player: {
                    pitcher: player.pitcher || [],
                    batter: player.batter || [],
                    fielder: player.fielder || [],
                },
                team: {
                    pitcher: team.pitcher || [],
                    batter: team.batter || [],
                    fielder: team.fielder || [],
                    winloss: team.winloss || [],
                },
            }));
        } catch (error) {
            console.log(error);
        }
    };
};

export {
    ACTIONS, getCustomeLeaderBoard, getYear, getYearSeasonRanges, getPlayers, getReports, getTeams, saveCustom,
    deleteCustomReport, getReport, getReportConfig, getPlayerDetail, resetTableList,
    updateCustom, updateCustomList, sortContentTable, getPlayer,
};
